<!-- Component that implements the navbar layout -->
<template lang="html">
  <v-app>
    <app-menu></app-menu>
    <app-content></app-content>
    <app-footer></app-footer>
    <app-snackbar></app-snackbar>
    <app-informacao></app-informacao>
  </v-app>
</template>

<script>
  export default {
    components: {
      'app-menu': () => import('@/components/app-layouts/app-menu/menu.vue'),
      'app-content': () => import('@/components/app-layouts/app-content/content.vue'),
      'app-footer': () => import('@/components/app-layouts/app-footer/footer.vue'),
      'app-snackbar': () => import('@/components/app-layouts/app-snackbar/snackbar'),
      'app-informacao': () => import('@/components/app-layouts/app-informacao/informacao')
    }
  }
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// layout.vue?b8dc3f44